import { Show } from "solid-js";

export function EstateMapOverlay(props: {
  compact: boolean;
  zoomPercent: string;
  pageCount: number;
  representedPageCount: number;
  clusterCount: number;
  hasWeak: boolean;
  hasImportant: boolean;
  hasBroken: boolean;
  hasSelection: boolean;
  onZoomOut: () => void;
  onZoomIn: () => void;
  onFit: () => void;
}) {
  return (
    <>
      <div class="signal-estate-map-toolbar">
        <div class="signal-estate-map-caption">
          <strong>
            {props.compact
              ? `${props.clusterCount} ${props.clusterCount === 1 ? "cluster" : "clusters"}`
              : `${props.pageCount} ${props.pageCount === 1 ? "page" : "pages"}`}
          </strong>
          <span>
            {props.compact
              ? `${props.representedPageCount} representative ${
                  props.representedPageCount === 1 ? "page" : "pages"
                } shown`
              : `across ${props.clusterCount} ${
                  props.clusterCount === 1 ? "cluster" : "clusters"
                } / select a page for context`}
          </span>
        </div>
        <Show when={!props.compact}>
          <fieldset class="signal-map-controls">
            <legend>Estate map controls</legend>
            <button
              type="button"
              aria-label="Zoom out"
              onClick={props.onZoomOut}
            >
              -
            </button>
            <span class="signal-map-zoom-label">{props.zoomPercent}</span>
            <button type="button" aria-label="Zoom in" onClick={props.onZoomIn}>
              +
            </button>
            <button
              type="button"
              aria-label="Fit estate to view"
              onClick={props.onFit}
            >
              Fit
            </button>
          </fieldset>
        </Show>
      </div>

      <div class="signal-estate-inline-legend">
        <Show when={props.hasWeak}>
          <span>
            <i class="is-weak" aria-hidden="true" /> Needs attention
          </span>
        </Show>
        <Show when={props.hasImportant}>
          <span>
            <i class="is-important" aria-hidden="true">
              !
            </i>{" "}
            Linked to a priority issue
          </span>
        </Show>
        <Show when={props.hasSelection}>
          <span>
            <i class="is-selected" aria-hidden="true" /> Selected
          </span>
        </Show>
        <Show when={props.hasBroken}>
          <span>
            <i class="is-broken" aria-hidden="true" /> Recorded weak connection
          </span>
        </Show>
      </div>
    </>
  );
}
